import { Vector3, Vector2 } from "./vector";
import { s } from "@kosmod/pancake";

export const Box3 = s.o({
  start: Vector3,
  end: Vector3,
});
export const Box2 = s.ref<Box2>()(s.o({
  start: Vector2,
  end: Vector2,
}));
export type Box3 = { start: Vector3, end: Vector3 };
export type Box2 = { start: Vector2, end: Vector2 };

export const Line2 = s.ref<Line2>()(s.o({
  start: Vector2,
  end: Vector2,
}));

export const Line3 = s.o({
  start: Vector3,
  end: Vector3,
});
export type Line2 = { start: Vector2, end: Vector2 };
export type Line3 = { start: Vector3, end: Vector3 };

/**
 * Generate an array of each coordinate
 * of a (assumedly already aligned) box
 * @param box box.start & box.end should already be `.floor()`'d
 */
export function* integerCoordinates2D(box: Box2) {
  const vector: Vector2 = { x: 0, y: 0 };

  for (let x = box.start.x; x < box.end.x; x++) {
    for (let y = box.start.y; y < box.end.y; y++) {
      vector.x = x;
      vector.y = y;
      yield vector;
    }
  }
}

export function intersectionBox2D(boxA: Box2, boxB: Box2): Box2 {
  return {
    start: {
      x: Math.max(boxA.start.x, boxB.start.x),
      y: Math.max(boxA.start.y, boxB.start.y),
    },
    end: {
      x: Math.min(boxA.end.x, boxB.end.x),
      y: Math.min(boxA.end.y, boxB.end.y),
    },
  }
}